var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_00",
    transform: "translate(-145.000000, -227.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(145.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9553571,183.035714 L17.2767857,180.714286 L7.14285714,180.714286 L7.14285714,179.285714 L17.2767857,179.285714 L14.9553571,176.964286 L15.9375,175.9375 L20,180 L15.9375,184.0625 L14.9553571,183.035714 Z M16.0267857,186.071429 L16.3839286,185.714286 L18.2142857,185.714286 C17.2916629,187.023817 16.1086371,188.065472 14.6651771,188.839286 C13.22172,189.613099 11.6666743,190 10,190 C7.23212857,190 4.87352286,189.025307 2.92410857,187.075891 C0.974692571,185.126477 0,182.767871 0,180 C0,177.232129 0.974692571,174.873523 2.92410857,172.924109 C4.87352286,170.974691 7.23212857,170 10,170 C11.6666743,170 13.22172,170.3869 14.6651771,171.160714 C16.1086371,171.934529 17.2916629,172.976183 18.2142857,174.285714 L16.3839286,174.285714 L16.0267857,173.928571 C14.3601114,172.261897 12.3512029,171.428571 10,171.428571 C7.61903429,171.428571 5.59524571,172.261897 3.92857143,173.928571 C2.26189657,175.595246 1.42857143,177.619034 1.42857143,180 C1.42857143,182.380966 2.26189657,184.404754 3.92857143,186.071429 C5.59524571,187.738103 7.61903429,188.571429 10,188.571429 C12.3512029,188.571429 14.3601114,187.738103 16.0267857,186.071429 Z",
    id: "Page-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.197dad63e38a11fb71e18a2172fe9675.svg";
export { ForwardRef as ReactComponent };